export const getStatus = (
  isActive: boolean,
  effectiveFrom: string,
  effectiveTo: string,
): { label: string; color: 'default' | 'error' | 'success' | 'warning' } => {
  const currentTime = new Date();
  const from = new Date(effectiveFrom);
  const to = new Date(effectiveTo);

  if (!isActive) {
    return { label: 'Disabled', color: 'error' };
  } else if (currentTime < from || currentTime > to) {
    return { label: 'Inactive', color: 'default' };
  } else {
    return { label: 'Active', color: 'success' };
  }
};
